import styled from 'styled-components'

export const ExportDescription = styled.div`
  line-height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;

  & > span {
    max-width: 366px;
    text-align: center;
    margin-top: 144px;
  }
`
